export const DEFAULT_ACTIVITY_HELP_TEXT =
  "Insert Rationale here";

export const ACTIVITY_HELP_TEXT_V2: Record<string, string> = {
  "Manual journal entries, adjustments, transfers, error corrections": "Insert Rationale here",
  "Posting corrections and adjustments": "Insert Rationale here",
  "Preparation of reclassifications": "Insert Rationale here",
  "Review & approval of reclassifications": "Insert Rationale here",
  "Posting of reclassifications": "Insert Rationale here",
  "Preparation of accruals & provisions": "Insert Rationale here",
  "Review & approval of accruals and provisions": "Insert Rationale here",
  "Posting of accruals and provisions": "Insert Rationale here",
  "Sub-ledger reconciliations, banks recs, production quantities & stock": "Insert Rationale here",
  "Balance sheet reconciliation - preparation": "Insert Rationale here",
  "Balance sheet reconciliation - review & approval": "Insert Rationale here",
  "Balance sheet reconciliation - adjustments": "Insert Rationale here",
  "Reconciliation Task 5": "Insert Rationale here",
  "Reconciliation Task 6": "Insert Rationale here",
  "Reconciliation Task 7": "Insert Rationale here",
  "Transaction postings, cross charges, asset transfer": "Insert Rationale here",
  "Daily Reconciliation and adjustments": "Insert Rationale here",
  "Monthly Reconciliation and adjustments": "Insert Rationale here",
  "Payments and Settlements": "Insert Rationale here",
  "Intercompany Task 5": "Insert Rationale here",
  "Intercompany Task 6": "Insert Rationale here",
  "Intercompany Task 7": "Insert Rationale here",
  "Period open/closing, cost allocation, forex revaluation, depreciation, project and order settlement": "Insert Rationale here",
  "Close Task 2": "Insert Rationale here",
  "Close Task 3": "Insert Rationale here",
  "Close Task 4": "Insert Rationale here",
  "Close Task 5": "Insert Rationale here",
  "Close Task 6": "Insert Rationale here",
  "Close Task 7": "Insert Rationale here",
  "Misc Task 1": "Insert Rationale here",
  "Misc Task 2": "Insert Rationale here",
  "Misc Task 3": "Insert Rationale here",
  "Misc Task 4": "Insert Rationale here",
  "Misc Task 5": "Insert Rationale here",
  "Misc Task 6": "Insert Rationale here",
  "Misc Task 7": "Insert Rationale here",
};

const normalizeActivityName = (activityName: string): string =>
  activityName.replace(/\s+/g, " ").trim();

const warnedActivities = new Set<string>();
let runtimeDefaultHelpText: string | null = null;
let runtimeActivityHelpMap: Record<string, string> | null = null;

export function setRuntimeActivityHelpTextConfig(config: {
  defaultText?: string;
  activityMap?: Record<string, string>;
}): void {
  runtimeDefaultHelpText =
    typeof config.defaultText === "string" && config.defaultText.trim().length > 0
      ? config.defaultText
      : null;

  if (config.activityMap && typeof config.activityMap === "object") {
    const normalized: Record<string, string> = {};
    for (const [key, value] of Object.entries(config.activityMap)) {
      const normalizedKey = normalizeActivityName(key);
      if (!normalizedKey) continue;
      normalized[normalizedKey] = typeof value === "string" ? value : "";
    }
    runtimeActivityHelpMap = normalized;
  } else {
    runtimeActivityHelpMap = null;
  }
}

export function getActivityHelpText(activityName: string): string {
  const normalized = normalizeActivityName(activityName);
  const hit = runtimeActivityHelpMap?.[normalized] ?? ACTIVITY_HELP_TEXT_V2[normalized];
  if (hit) return hit;

  if (typeof window !== "undefined" && process.env.NODE_ENV !== "production" && !warnedActivities.has(normalized)) {
    warnedActivities.add(normalized);
    console.info(`[V2 HelpText] Missing activity mapping: ${normalized}`);
  }

  return runtimeDefaultHelpText || DEFAULT_ACTIVITY_HELP_TEXT;
}
